import { removeToken } from "../setup/api";

export default {
  getConfig(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/partners/config")
        .then(function(response) {
          context.commit("setConfig", response.data);

          // set title
          document.title = response.data.title;

          // set favicon
          let link = document.createElement("link");
          link.rel = "icon";
          link.href = response.data.favicon;
          document.head.appendChild(link);

          resolve(response.data);
        })
        .catch(reject);
    });
  },

  postLogin(context) {
    return new Promise((resolve, reject) => {
      context.commit("setLoading", true);
      context
        .dispatch("user/get")
        .then(user => {
          resolve(user);
          context.commit("user/setLogged", true);
        })
        .catch(reject)
        .finally(() => {
          context.commit("setLoading", false);
        });
    });
  },

  logout(context) {
    return new Promise(resolve => {
      removeToken();
      context.commit("user/reset");
      resolve();
    });
  }
};
